import { omit } from 'lodash';

import UsersConstants from '../constants/Users.constants';

export default (state = {}, action) => {
  switch (action.type) {
    case 'DATA_SOURCE_DISCONNECT_ASANA':
      return { ...state, hasAsanaIntegration: false };
    case 'MYTIME_GET_RESPONSE': {
      return { ...state, ...action.payload };
    }
    case 'UPDATE_PULSE_RESPONSE':
      return { ...state, ...action.payload.user };
    case 'UPDATE_USER_DATA_RESPONSE':
      return { ...state, ...action.payload };
    case 'UPDATE_PROFILE_RESPONSE':
      return { ...state, ...action.payload.user };
    case 'GET_RECURRING_MEETINGS_RESPONSE':
      return { ...state, recurringMeetings: action.payload };
    case 'LOAD_ASANA_DATA_RESPONSE':
      return { ...state, asanaData: action.payload };
    case 'GENERATE_API_TOKEN':
      return { ...state, accessToken: action.payload };
    case 'GET_ACCESS_TOKEN':
      return { ...state, accessToken: action.payload };
    case 'LOAD_JIRA_DATA_RESPONSE':
      return { ...state, jiraData: action.payload };
    case 'NEW_FEATURE_MODAL_PUT_RESPONSE':
      return {
        ...state,
        features: action.payload,
      };
    case 'ADD_CHART_RESPONSE':
    case 'REMOVE_CHART_RESPONSE':
      return {
        ...state,
        selectedMembership: {
          ...state.selectedMembership,
          charts: action.payload.data,
        },
      };
    case 'LINK_RECURRING_MEETINGS_RESPONSE':
    case 'SET_RECURRING_MEETING_REQUEST':
    case 'SET_RECURRING_MEETING_RESPONSE':
      return {
        ...state,
        recurringMeetings: state.recurringMeetings.map(recurringMeeting => {
          if (
            recurringMeeting.id === action.payload.recurringMeeting?.id ||
            action.payload.recurringMeetingsIds?.includes(recurringMeeting.id)
          )
            return { ...recurringMeeting, hasWorkspace: true };
          return recurringMeeting;
        }),
      };
    case 'UPDATE_ORGANIZATION_REQUEST':
    case 'UPDATE_ORGANIZATION_RESPONSE':
    case 'UPDATE_ORGANIZATION_ERROR':
      if (!action.payload.organization.name) {
        return state;
      }
      return { ...state, organization: action.payload.organization.name };
    case 'UPDATE_NOTIFICATIONS_SETTINGS_REQUEST':
    case 'UPDATE_NOTIFICATIONS_SETTINGS_ERROR':
      return { ...state, notificationSettings: action.payload.notificationsSettings };
    case 'UPDATE_SUGGESTED_TOPICS_REQUEST':
    case 'UPDATE_SUGGESTED_TOPICS_ERROR':
      return { ...state, suggestedTopics: action.payload.suggestedTopics };
    case 'SKIP_START_GUIDE_SECTION_REQUEST':
      return {
        ...state,
        skipedStartGuideSections: [...state.skipedStartGuideSections, action.payload.section],
      };
    case 'SKIP_START_GUIDE_SECTION_ERROR':
      return {
        ...state,
        skipedStartGuideSections: state.skipedStartGuideSections.filter(section => section !== action.payload.section),
      };
    case 'UPDATE_MEMBER_REQUEST':
    case 'UPDATE_MEMBER_ERROR':
      if (state.selectedMembership.id === action.payload.member.memberId) {
        return {
          ...state,
          ...omit(action.payload.member, ['memberId']),
        };
      }
      return state;
    case 'HIDE_SUGGEST_MEMBER_RESPONSE':
      return {
        ...state,
        skipedMembersIds: [...state.skipedMembersIds, action.payload.id],
      };
    case 'UPDATE_SEEN_DISCUSSION_ROOM_SUCCESS':
      return {
        ...state,
        hasSeenDiscussionRoom: true,
      };
    case 'UPDATE_SEEN_ZOOM_ANNOUNCEMENT_BANNER_SUCCESS':
      return {
        ...state,
        hasSeenZoomAnnouncementBanner: true,
      };
    case 'UPDATE_SHOW_NOTIFICATION_SETTINGS_CARD':
      return {
        ...state,
        show_notification_settings_card: action.payload,
      };
    case UsersConstants.Actions.UPDATE_USER_FLAG_SUCCESS:
      return {
        ...state,
        flags: { ...state.flags, [action.payload.flag]: action.payload.value },
      };
    default:
      return state;
  }
};
